// Lazy loader for marketing pixels (Meta Pixel).
// Google Ads tag is loaded statically in index.html alongside GA4 — its data
// collection is fully gated by Consent Mode v2 (`ad_storage` etc.), so we only
// need to manage Meta Pixel here.

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let metaLoaded = false;

function loadMetaPixelScript() {
  if (metaLoaded || !META_PIXEL_ID) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;
  /* eslint-disable */
  // Meta Pixel snippet (verbatim from Meta docs).
  !function(f,b,e,v,n,t,s){
    if(f.fbq)return;
    n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];
    t=b.createElement(e);t.async=!0;
    t.src=v;
    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  metaLoaded = true;
}

export function setMarketingConsent(granted) {
  if (!META_PIXEL_ID) return;
  if (granted) {
    loadMetaPixelScript();
    if (typeof window.fbq === "function") {
      window.fbq("consent", "grant");
      // Init + initial PageView fire only once per page load.
      if (!window.__metaPixelInited) {
        window.fbq("init", META_PIXEL_ID);
        window.fbq("track", "PageView");
        window.__metaPixelInited = true;
      }
    }
  } else if (typeof window.fbq === "function") {
    // Pixel was loaded earlier (user revoked) — tell Meta to stop tracking.
    window.fbq("consent", "revoke");
  }
}
